
/* tslint:disable:quotemark */
import { defineMessages } from "react-intl";


const MESSAGES = defineMessages({
  apronAffectsPosition: {
    id: "ApronAffects.position",
    defaultMessage: "Attention: Apron width of 18 mm leads to the displacement of the trough position."
  },
  apronHeight: {
    id: "Apron.height",
    defaultMessage: "Height of apron in mm",
  },
  apronHeightRequiredHint: {
    id: "ApronHeightRequiredHint.hint",
    defaultMessage: "Note:",
  },
  apronHeightAndDimensionsRequiredMessage: {
    id: "ApronHeightAndDimensionsRequiredMessage.message",
    defaultMessage: "To position a towel rail, you need a 150 mm apron. As the width of your washbasin is not sufficient for an apron placement, your plate needs to be enlarged. Would you like to continue?"
  },
  apronHeightAndDimensionsForTowelRailRequiredMessage: {
    id: "apronHeightAndDimensionsForTowelRailRequiredMessage.message",
    defaultMessage: "To position a towel rail, you need a 150 mm apron. As the width of your washbasin is not sufficient for an apron placement, your plate needs to be enlarged. Would you like to continue?"
  },
  apronHeightAndDimensionsForTissueDispenserRequiredMessage: {
    id: "apronHeightAndDimensionsForTissueDispenserRequiredMessage.message",
    defaultMessage: "To position a cosmetic tissue dispenser, you need a 150 mm apron. As the width of your washbasin is not sufficient for an apron placement, your plate needs to be enlarged. Would you like to continue?"
  },
  apronHeightAndDimensionsForCutOutDisposalRequiredMessage: {
    id: "apronHeightAndDimensionsForCutOutDisposalRequiredMessage.message",
    defaultMessage: "To position this cut out, you need a 150 mm apron. As the width of your washbasin is not sufficient for an apron placement, your plate needs to be enlarged. Would you like to continue?"
  },
  apronHeightRequiredMessage: {
    id: "ApronHeightRequiredMessage.message",
    defaultMessage: "Activate apron and set apron height to {requiredHeight} mm. Continue?",
  },
  apronHeightForTowelRailRequiredMessage: {
    id: "apronHeightForTowelRailRequiredMessage.message",
    defaultMessage: "Activate apron and set apron height to {requiredHeight} mm. Continue?",
  },
  apronHeightForTissueDispenserRequiredMessage: {
    id: "apronHeightForTissueDispenserRequiredMessage.message",
    defaultMessage: "Activate apron and set apron height to {requiredHeight} mm. Continue?",
  },
  apronHeightForCutOutDisposalRequiredMessage: {
    id: "apronHeightForCutOutDisposalRequiredMessage.message",
    defaultMessage: "Activate apron and set apron height to {requiredHeight} mm. Continue?",
  },
  apronHeightRequiredChoiceMessage: {
    id: "ApronHeightRequiredChoiceMessage.message",
    defaultMessage: "For a better look of your washbasin, we recommend you to select an apron to use:",
  },
  apronHeightRequiredChoice60: {
    id: "apronHeightRequiredChoice60.60",
    defaultMessage: "Change the apron height to 60 mm",
  },
  apronHeightRequiredChoice150: {
    id: "apronHeightRequiredChoice150.150",
    defaultMessage: "Change the apron height to 150 mm",
  },
  apronHeightRequiredChoiceSkip: {
    id: "apronHeightRequiredChoiceSkip.skip",
    defaultMessage: "Maintain apron height",
  },
  apronHeightRequiredChoiceNoSleeve: {
    id: "apronHeightRequiredChoiceNoSleeve.nosleeve",
    defaultMessage: "Maintain apron height and continue without the sleeve",
  },
  apronHeightError: {
    id: "ApronHeightError.message",
    defaultMessage: "Your value is out of range",
  },
  surgeEdgeLabelWithout: {
    id: "SurgeEdgeLabelWithout.without",
    defaultMessage: "without",
  },
  surgeEdgeLabelWith: {
    id: "SurgeEdgeLabelWith.with",
    defaultMessage: "with surge edge (3 mm)",
  },
  surgeEdgeLabelWithBackSplash: {
    id: "SurgeEdgeLabelWithBackSplash.withbacksplash",
    defaultMessage: "with backsplash",
  },
  surgeEdgeLabelWithBackSplashBack: {
    id: "SurgeEdgeLabelWithBackSplashBack.withbacksplashback",
    defaultMessage: "at the back (Standard)",
  },
  surgeEdgeLabelWithBackSplashBackHeight: {
    id: "SurgeEdgeLabelWithBackSplashBackHeight.withbacksplashbackheight",
    defaultMessage: "Height of backsplash in mm",
  },
  apronLabelWith: {
    id: "ApronLabel.with",
    defaultMessage: "with apron",
  },
  apronLabelWithout: {
    id: "ApronLabel.without",
    defaultMessage: "without apron (Standard)",
  },
  apronForcedWidthIncrease: {
    id: "ApronForcedWidthIncrease.message",
    defaultMessage: "If you deselect the apron, the original dimensions of your configuration will be restored."
  }
});

export default MESSAGES;